module.exports = __webpack_public_path__ + "img/authorization.237652df.png";